<div class="modal-header">
    <h4 class="modal-title">Skift kontor</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <table class="table table-hover table-striped table-sm">
        <thead>
            <th scope="col">Kontor</th>
            <th scope="col">Nr</th>
        </thead>
        <tbody>
            <tr *ngFor="let office of offices"
            (click)="onSwitchOffice(office)">
                <td>{{office?.kontornavn}}</td>
                <td>{{office?.kontorId}}</td>
            </tr>
        </tbody>
    </table>
</div>
